import React, {useEffect, useRef, useState} from 'react';
import CollapsableBox from "../collapsableBox/CollapsableBox";
import 'react-phone-number-input/style.css';
import "./more-configurations-section.css";
import PhoneNumber from "../forms/phoneNumber/PhoneNumber";
import {Button} from "antd";
import {updatePreviewPhoneNumber} from "../../api/updatePreviewPhoneNumber";
import useUserContext from "../../hooks/useUserContext";
import useAppContext from "../../hooks/useAppContext";
import useToast from "../../hooks/useToast";
import {ToastSkin} from "../../context/ToastContext";
import PreviewPhoneNumber from "../previewPhoneNumber/PreviewPhoneNumber";
import ShopConsentPolicy from "../shopConsentPolicy/ShopConsentPolicy";
import NotificationsEmail from "../notificationsEmail/NotificaitonsEmail";

interface MoreConfigurationsSectionProps {
    isInitiallyOpen?: boolean;
}

const MoreConfigurationsSection = ({ isInitiallyOpen }: MoreConfigurationsSectionProps) => {
    const sectionRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if(isInitiallyOpen) {
            sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [isInitiallyOpen]);

    return (
        <CollapsableBox title="Configurations" isInitiallyOpen={isInitiallyOpen}>
            <div ref={sectionRef} className="more-configurations-section">
                <ShopConsentPolicy />
                <PreviewPhoneNumber />
                <NotificationsEmail />
            </div>
        </CollapsableBox>
    )
}

export default MoreConfigurationsSection;